module.exports = __webpack_public_path__ + "static/media/193-norfolk-island.a14f49b1.svg";